


//////////Main Code//////////
var variant = null;
var export_Image = [];
var previewUrl;
var text;
var stage;
var text_position = 1;
var text_font='SuperGlue'
var uploaded = false;
const font_List= ['ApeMount','BettinaSignature','CollegiateheavyoutlineMedium',
                    'Foxbot','MontserratBlack','Playball',
                    'SuperGlue','VegapunkFree'];

const font_offeset_1 = [[34,6,17,2.5],//ApeMount
                        [23,22,13,2.5],//BettinaSignature
                        [40,2.5,16,2.5],//CollegiateheavyoutlineMedium
                        [34,2,15,2.5],//Foxbot
                        [36,3.5,16,2.5],//MontserratBlack
                        [45,5,15,2.5],//Playball
                        [38,5,15,2.5],//SuperGlue
                        [33,0,15,2.5]];//VegapunkFree

const font_offeset_2 = [[34,6,17,2.5],//ApeMount
                        [23,5,13,2.5],//BettinaSignature
                        [40,-2,16,2.5],//CollegiateheavyoutlineMedium
                        [34,0,15,2.5],//Foxbot
                        [36,3.5,16,2.5],//MontserratBlack
                        [45,-4,15,2.5],//Playball
                        [38,5,15,2.5],//SuperGlue
                        [33,3,15,2.5]];//VegapunkFree

const font_offeset_3 = [[25,0,8,2.5],//ApeMount
                        [20,0,15,2.5],//BettinaSignature
                        [29.5,0,3,2.5],//CollegiateheavyoutlineMedium
                        [23,-2,7,2.5],//Foxbot
                        [27,0,6,2.5],//MontserratBlack
                        [31,-3,0,2.5],//Playball
                        [32,0,5,2.5],//SuperGlue
                        [24.5,0,6,2.5]];//VegapunkFree

const font_offeset_4 = [[25,0,14,2.5],//ApeMount
                        [20,0,10,2.5],//BettinaSignature
                        [29.5,0,8,2.5],//CollegiateheavyoutlineMedium
                        [23,-2,10,2.5],//Foxbot
                        [27,0,12,2.5],//MontserratBlack
                        [31,-3,10,2.5],//Playball
                        [32,0,8,2.5],//SuperGlue
                        [24.5,0,13,2.5]];//VegapunkFree

var generateRandomString = (length) => {
                            let result = '';
                            var characters =
                              'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
                            var charactersLength = characters.length;
                            for (let i = 0; i < length; i++) {
                              result += characters.charAt(Math.floor(Math.random() * charactersLength));
                            }
                            return (`${result}_${new Date(Date.now()).getTime()}`);
                          };



const font_Mapping = new Map();
for (var i = 0; i < font_List.length; i++) {
    font_Mapping.set(font_List[i], [
        font_offeset_1[i],
        font_offeset_2[i],
        font_offeset_3[i],
        font_offeset_4[i],
    ]
        );
}




const container=document.getElementsByClassName("product__media-list-wrapper")[0];
document.addEventListener('variant:changed', function (event) {
    variant = (function (myvariant) {
        variant = myvariant;
        return (variant);
    })(event.detail.variant);
    (function (product_layer, imageurl, mask_layer, maskurl) {
        var uploadedImage = new Konva.Image({
            x: stage.getWidth() / 2,
            y: stage.getHeight() / 2,
            width: stage.getWidth(),
            height: stage.getHeight(),
            draggable: false
        });
        product_layer.add(uploadedImage);
        var MaskImage = new Konva.Image({
            x: stage.getWidth() / 2,
            y: stage.getHeight() / 2,
            width: stage.getWidth(),
            height: stage.getHeight(),
            draggable: false,
        });

        //Product
        imgObj = new Image();
        imgObj.onload = function () {
            uploadedImage.image(imgObj);  // give the image to the cannvas image object.
            var padding = 0;
            var w = imgObj.width;
            var h = imgObj.height;
            var targetW = stage.getWidth() - (2 * padding);
            var targetH = stage.getHeight() - (2 * padding);
            var widthFit = targetW / w;
            var heightFit = targetH / h;
            var scale = (widthFit > heightFit) ? heightFit : widthFit;
            w = parseInt(w * scale, 10);
            h = parseInt(h * scale, 10);
            uploadedImage.size({
                width: w,
                height: h
            });
            (function (shape) {
                shape.x((stage.getWidth() - shape.getWidth()) / 2);
                shape.y((stage.getHeight() - shape.getHeight()) / 2);
            })(uploadedImage);
            product_layer.draw();
        }
        imgObj.crossOrigin = 'Anonymous';
        imgObj.src = imageurl;
        mask_imgObj.onload = function () {
            MaskImage.image(mask_imgObj);  // give the image to the cannvas image object.
            var padding = 0;
            var w = mask_imgObj.width;
            var h = mask_imgObj.height;
            var targetW = stage.getWidth() - (2 * padding);
            var targetH = stage.getHeight() - (2 * padding);
            var widthFit = targetW / w;
            var heightFit = targetH / h;
            var scale = (widthFit > heightFit) ? heightFit : widthFit;
            w = parseInt(w * scale, 10);
            h = parseInt(h * scale, 10);
            MaskImage.size({
                width: w,
                height: h
            });
            (function (shape) {
                shape.x((stage.getWidth() - shape.getWidth()) / 2);
                shape.y((stage.getHeight() - shape.getHeight()) / 2);
            })(MaskImage);
            MaskImage.draw();
        }
        mask_imgObj.crossOrigin = 'Anonymous';
        stage.draw();
    })(product_layer, variant.featured_media.preview_image.src,
        product_mask_layer, variant.featured_media.preview_image.src);
    var parent = document.getElementsByClassName("product__media-item");
    for (var i = 1; i < parent.length; i++) {
        parent[i].remove();
    }
    //remove all class contain product__thumbnail-list-inner 
    var parent = document.getElementsByClassName("product__thumbnail-list-inner");
    for (var i = 0; i < parent.length; i++) {
        parent[i].remove();
    }
    var els = document.querySelectorAll('flickity-controls')
    for (var i = 0; i < els.length; i++) {
        els[i].remove();
    }


});

stage = new Konva.Stage({
    container: container,
    width: container.offsetWidth,
    height: container.offsetHeight,
});
var product_layer = new Konva.Layer({
    name: 'product_layer'
});
var imgObj = new Image();
var product_mask_layer = new Konva.Layer({
    name: 'mask_product_layer',
    listening: false,
});
var mask_imgObj = new Image();
var layer_One = new Konva.Layer({
    name: 'layer_One'
});

// layer_One.add(new Konva.Line({
//     points: [0, container.offsetHeight / 2, container.offsetWidth, container.offsetHeight / 2],
//     stroke: 'black',
//     strokeWidth: 1,
//     lineCap: 'round',
//     lineJoin: 'round',
//     name: 'line'
// }));

// layer_One.add(new Konva.Line({
//     points: [0, container.offsetHeight / 2.85, container.offsetWidth, container.offsetHeight / 2.85],
//     stroke: 'purple',
//     strokeWidth: 1,
//     lineCap: 'round',
//     lineJoin: 'round',
//     name: 'line'
// }));


// layer_One.add(new Konva.Line({
//     points: [0, (container.offsetHeight / 2)+(container.offsetHeight / 2.8), container.offsetWidth, (container.offsetHeight / 2)+(container.offsetHeight / 2.8)],
//     stroke: 'blue',
//     strokeWidth: 1,
//     lineCap: 'round',
//     lineJoin: 'round',
//     name: 'line'
// }));

// layer_One.add(new Konva.Line({
//     points: [container.offsetWidth / 2, 0, container.offsetWidth / 2, container.offsetHeight],
//     stroke: 'green',
//     strokeWidth: 1,
//     lineCap: 'round',
//     lineJoin: 'round',
//     name: 'line'
// }));

// layer_One.add(new Konva.Line({
//     points: [(container.offsetWidth / 2)-(container.offsetWidth /5.8) , 0, (container.offsetWidth / 2)-(container.offsetWidth / 5.8), container.offsetHeight],
//     stroke: 'white',
//     strokeWidth: 1,
//     lineCap: 'round',
//     lineJoin: 'round',
//     name: 'line'
// }));

// layer_One.add(new Konva.Line({
//     points: [(container.offsetWidth / 2)-(container.offsetWidth /5.3) , 0, (container.offsetWidth / 2)-(container.offsetWidth / 5.3), container.offsetHeight],
//     stroke: 'white',
//     dash: [10, 5],
//     strokeWidth: 1,
//     lineCap: 'round',
//     lineJoin: 'round',
//     name: 'line'
// }));


// layer_One.add(new Konva.Line({
//     points: [(container.offsetWidth / 2)+(container.offsetWidth /5.8) , 0, (container.offsetWidth / 2)+(container.offsetWidth / 5.8), container.offsetHeight],
//     stroke: 'red',
//     strokeWidth: 1,
//     lineCap: 'round',
//     lineJoin: 'round',
//     name: 'line'
// }));

// layer_One.add(new Konva.Line({
//     points: [(container.offsetWidth / 2)+(container.offsetWidth /5.3) , 0, (container.offsetWidth / 2)+(container.offsetWidth / 5.3), container.offsetHeight],
//     dash: [10, 5],
//     stroke: 'red',
//     strokeWidth: 1,
//     lineCap: 'round',
//     lineJoin: 'round',
//     name: 'line'
// }));






product_layer.add(new Konva.Rect({
    x: 0,
    y: 0,
    width: container.offsetWidth,
    height: container.offsetHeight,
    fill: 'white',
    name: 'product_background'
}));
stage.add(product_layer);
stage.add(layer_One);
text = (function (design_layer, text, text_font, color) {
    var text = new Konva.Text({
        width: container.offsetWidth,
        text: text,
        fontFamily: text_font,
        fontSize: font_Mapping.get(text_font)[0][0]*container.offsetWidth/400,
        fill: color,
        draggable: false,
        name: 'text',
        align: "left",
    });
    design_layer.add(text);
    stage.draw();
    return text;
})(layer_One, '', text_font, 'black');

document.getElementById("text_input").addEventListener("keyup", function () {
    if ((function (str) {
        if (document.getElementById("tac_CheckBox").checked == true && document.getElementById("text_input").value.length>0) {
            if(/^[\x00-\x7F]*$/.test(document.getElementById("text_input").value)){
                document.getElementById("pc_remark").style.color= "gray";
                document.getElementById("AddToCart").disabled = false;
                document.getElementById("StickyAddToCart").disabled = false;
                document.getElementById("AddToCart").classList.add("button--primary");
                document.getElementById("StickyAddToCart").classList.add("button--primary");
                document.getElementById("AddToCart").classList.remove("button--ternary");
                document.getElementById("StickyAddToCart").classList.remove("button--ternary");
            }
        }
        else {
            document.getElementById("pc_remark").style.color= "gray";
        }


        return /^[\x00-\x7F]*$/.test(str);
       
    })(this.value) == false) {
        document.getElementById("pc_remark").style.color= "red";
        document.getElementById("AddToCart").disabled = true;
        document.getElementById("StickyAddToCart").checked = true;
        document.getElementById("AddToCart").classList.remove("button--primary");
        document.getElementById("StickyAddToCart").classList.remove("button--primary");
        document.getElementById("AddToCart").classList.add("button--ternary");
        document.getElementById("StickyAddToCart").classList.add("button--ternary");
        return
    }
    
    text.text(this.value);
    if(text.text().length==0){
        document.getElementById("pc_remark").style.color= "gray";
        document.getElementById("AddToCart").disabled = true;
        document.getElementById("StickyAddToCart").checked = true;
        document.getElementById("AddToCart").classList.remove("button--primary");
        document.getElementById("StickyAddToCart").classList.remove("button--primary");
        document.getElementById("AddToCart").classList.add("button--ternary");
        document.getElementById("StickyAddToCart").classList.add("button--ternary");
    }



    document.getElementById("text_counter").innerHTML =
        `${document.getElementById("text_input").value.length}/${document.getElementById("text_input").attributes.maxlength.value}`;

    });


(function (product_layer, imageurl, mask_layer, maskurl) {
    var uploadedImage = new Konva.Image({
        x: stage.getWidth() / 2,
        y: stage.getHeight() / 2,
        width: 1000,
        height: 1000,
        draggable: false
    });
    product_layer.add(uploadedImage);
    var MaskImage = new Konva.Image({
        x: stage.getWidth() / 2,
        y: stage.getHeight() / 2,
        width: 1000,
        height: 1000,
        draggable: false,
    });
    mask_layer.add(MaskImage);
    //Product
    imgObj = new Image();
    imgObj.onload = function () {
        uploadedImage.image(imgObj);  // give the image to the cannvas image object.
        var padding = 0;
        var w = imgObj.width;
        var h = imgObj.height;
        var targetW = stage.getWidth() - (2 * padding);
        var targetH = stage.getHeight() - (2 * padding);
        var widthFit = targetW / w;
        var heightFit = targetH / h;
        var scale = (widthFit > heightFit) ? heightFit : widthFit;
        w = parseInt(w * scale, 10);
        h = parseInt(h * scale, 10);
        uploadedImage.size({
            width: w,
            height: h
        });
        (function (shape) {
            shape.x((stage.getWidth() - shape.getWidth()) / 2);
            shape.y((stage.getHeight() - shape.getHeight()) / 2);
        })(uploadedImage);
        product_layer.draw();
    }
    imgObj.crossOrigin = 'Anonymous';
    imgObj.src = imageurl;
    mask_imgObj.onload = function () {
        MaskImage.image(mask_imgObj);  // give the image to the cannvas image object.
        var padding = 0;
        var w = mask_imgObj.width;
        var h = mask_imgObj.height;
        var targetW = stage.getWidth() - (2 * padding);
        var targetH = stage.getHeight() - (2 * padding);
        var widthFit = targetW / w;
        var heightFit = targetH / h;
        var scale = (widthFit > heightFit) ? heightFit : widthFit;
        w = parseInt(w * scale, 10);
        h = parseInt(h * scale, 10);
        MaskImage.size({
            width: w,
            height: h
        });
        (function (shape) {
            shape.x((stage.getWidth() - shape.getWidth()) / 2);
            shape.y((stage.getHeight() - shape.getHeight()) / 2);
        })(MaskImage);
        MaskImage.draw();
    }
    mask_imgObj.crossOrigin = 'Anonymous';
    stage.draw();
})(product_layer, JSON.parse((currentProduct)).variants,
    product_mask_layer, JSON.parse((currentProduct)).variants);
(function (event, position) {
    if (event != undefined) {
        var parent = event.parentElement;
        var children = parent.children;
        for (var i = 0; i < children.length; i++) {
            children[i].classList.remove("selected");
        }
        event.classList.add("selected");
    }
    text.x(container.offsetWidth * 0.35);
    text.y(container.offsetHeight * 0.65);
    //p1
    if (position == "1") {
        text.align("left");
        (function (angle) {
            (function () {
                var rect = text;
                if (rect.offsetX() == 0 && rect.offsetY() == 0) {
                    rect.offset({ x: rect.width() / 2, y: rect.height() / 2 });
                    rect.position({ x: rect.position().x + rect.offsetX(), y: rect.position().y + rect.offsetY() })
                }
                return null;
            })();
            text.rotation(angle);
            text.align("left");
            text.fontSize(font_Mapping.get(text_font)[0][0]*container.offsetWidth/400),
            text.x(container.offsetWidth * 0.35+ font_Mapping.get(text_font)[0][1]*container.offsetWidth/400);
            text.y(container.offsetHeight * 0.35+ font_Mapping.get(text_font)[0][2]*container.offsetWidth/400);
            
        })(270);
    }
    if (position == "2") {
        text.align("left");
        text_position = "2";
        (function (angle) {
            (function () {
                var rect = text;
                if (rect.offsetX() == 0 && rect.offsetY() == 0) {
                    rect.offset({ x: rect.width() / 2, y: rect.height() / 2 });
                    rect.position({ x: rect.position().x + rect.offsetX(), y: rect.position().y + rect.offsetY() })
                }
                return null;
            })();
            text.rotation(angle);
        })(270);
        text.x(container.offsetWidth * 0.66- font_Mapping.get(text_font)[2]*container.offsetWidth/400);
        text.y(container.offsetHeight * 0.65);
    }
    if (position == "3") {
        text.align("center");
        (function (angle) {
            (function () {
                var rect = text;
                if (rect.offsetX() == 0 && rect.offsetY() == 0) {
                    rect.offset({ x: rect.width() / 2, y: rect.height() / 2 });
                    rect.position({ x: rect.position().x + rect.offsetX(), y: rect.position().y + rect.offsetY() })
                }
                return null;
            })();
            text.rotation(angle);
        })(0);
        text.x(container.offsetWidth * 0.5);
        text.y(container.offsetHeight * 0.5);
    }
    if (position == "4") {
        text.align("center");
        text_position = "4";
        (function (angle) {
            (function () {
                var rect = text;
                if (rect.offsetX() == 0 && rect.offsetY() == 0) {
                    rect.offset({ x: rect.width() / 2, y: rect.height() / 2 });
                    rect.position({ x: rect.position().x + rect.offsetX(), y: rect.position().y + rect.offsetY() })
                }
                return null;
            })();
            text.rotation(angle);
        })(0);
        text.x(container.offsetWidth * 0.5);
        text.y(container.offsetHeight * 0.88 - text.height() / 2);
    }
})(undefined, "1");


function pc_uploadImage()
{
    
    var temp=generateRandomString(16)
    var previewUrl = `https://dt2ch859s53v3.cloudfront.net/Fase/uploads/UAT/${temp}_preview.png`;
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    var raw = JSON.stringify({
      "design_Base64": layer_One.toDataURL({ pixelRatio: 3 }).split(',')[1],
      "preview_Base64": stage.toDataURL({ pixelRatio: 3 }).split(',')[1],
      "object_name": `${temp}`,
    });
    
    var requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: raw
    };
    fetch("https://n1ln7s62md.execute-api.ap-east-1.amazonaws.com/Prod/UploadImage", requestOptions)
    .then(response => response.text())
    .then(result =>pc_addtocart(previewUrl))
    .then(result =>  document.querySelector("button#AddToCart").click())
    .then(result =>  clearform())
    .catch(error => console.log('error', error));
    
}

function clearform(){
    var parent = document.getElementsByClassName("var-custdata");
    for (var i = 0; i < parent.length; i++) {
        parent[i].remove();
    }
}
function pc_addtocart(result)
{   
    var pcinputform =({
        "_customized_text":document.getElementById("text_input").value,
        "_customized_text_color":document.getElementById("text_color_containner").querySelector(".selected").dataset.color,
        "_customized_text_font": document.getElementById("pc_font_containner").querySelector(".selected").dataset.position,
        "_customized_text_position":document.getElementById("text_position_containner").querySelector(".selected").dataset.position,
        "_preview_image_url": result
    });
   
    (function (formEl) {
            for (const property in pcinputform) {
                    const el = Array.from(formEl.querySelectorAll("input[type='hidden']")).find(function (input) {
                        return input.getAttribute("name") === `properties[${property}]`;
                    });
                    if (el) {
                        el.setAttribute("value", pcinputform[property]);
                    } else {
                        const inputEl = document.createElement("input");
                        //set inputEl class = "var-custdata
                        inputEl.classList.add("var-custdata");
                        inputEl.setAttribute("type", "hidden");
                        inputEl.setAttribute("name", `properties[${property}]`);
                        inputEl.setAttribute("value", pcinputform[property])
                        formEl.appendChild(inputEl);  
                    }
            }
           uploaded = true;
    })(document.querySelector("button#AddToCart").closest("form"));
}



document.querySelector("button#AddToCart").addEventListener("click", function (e) {
        if(document.getElementById("drawer_open").classList.contains("active")){

            if(uploaded==false){
                e.preventDefault();
                console.log(document.getElementById("AddToCart"))
                document.getElementById("AddToCart").setAttribute("aria-busy", "true");
                pc_uploadImage();

            
        }
        uploaded=false;

        
    }

});
document.querySelector("button#StickyAddToCart").addEventListener("click", function (e) {
    if(document.getElementById("drawer_open").classList.contains("active")){

        if(uploaded==false){
            e.preventDefault();
            console.log(document.getElementById("StickyAddToCart"))
            document.getElementById("StickyAddToCart").setAttribute("aria-busy", "true");
            pc_uploadImage();
    }
    uploaded=false;
}


});
document.getElementById("pc_btn_reset").addEventListener("click", function () {
    document.getElementById("pc_remark").style.color= "gray";
    document.getElementById("text_input").value="";
    document.getElementById("text_counter").innerHTML="0/10";
    //remove all class "selected" in all pc-containner class
    var parent = document.getElementsByClassName("pc-containner");
    for (var i = 0; i < parent.length; i++) {
        for(var j=0;j<parent[i].children.length;j++){
            parent[i].children[j].classList.remove("selected");
        }
        let defalut = document.getElementsByClassName("default");
        for(var j=0;j<defalut.length;j++){
            defalut[j].click();
        }
        if(text!=undefined){
            text.text("");
        }
    }  
});
document.getElementById("drawer_open").addEventListener("click", function () {
    document.getElementById("pc_remark").style.color= "gray";
    document.getElementById("text_input").value="";
    text.text("");
    document.getElementById("AddToCart").disabled = false;
    document.getElementById("StickyAddToCart").disabled = false;
    document.getElementById("main_panle").classList.toggle("active");
    document.getElementById("drawer_open").classList.toggle("active");
    document.getElementById("drawer_close").classList.toggle("active");
    document.getElementById("tac_CheckBox").checked = false;
    document.getElementById("AddToCart").classList.add("button--primary");
    document.getElementById("StickyAddToCart").classList.add("button--primary");
    document.getElementById("AddToCart").classList.remove("button--ternary");
    document.getElementById("StickyAddToCart").classList.remove("button--ternary");

});
document.getElementById("drawer_close").addEventListener("click", function () {
    document.getElementById("pc_remark").style.color= "gray";
    document.getElementById("text_input").value="";
    text.text("");
    document.getElementById("AddToCart").disabled = true;
    document.getElementById("StickyAddToCart").disabled = true;
    document.getElementById("AddToCart").classList.remove("button--primary");
    document.getElementById("StickyAddToCart").classList.remove("button--primary");
    document.getElementById("AddToCart").classList.add("button--ternary");
    document.getElementById("StickyAddToCart").classList.add("button--ternary");

    document.getElementById("main_panle").classList.toggle("active");
    document.getElementById("drawer_open").classList.toggle("active");
    document.getElementById("drawer_close").classList.toggle("active");
});
document.getElementById("tac_CheckBox").addEventListener("click", function () {
    if (document.getElementById("tac_CheckBox").checked == true && document.getElementById("text_input").value.length>0) {
        if(/^[\x00-\x7F]*$/.test(document.getElementById("text_input").value)){
            document.getElementById("pc_remark").style.color= "gray";
            document.getElementById("AddToCart").disabled = false;
            document.getElementById("StickyAddToCart").disabled = false;
            document.getElementById("AddToCart").classList.add("button--primary");
            document.getElementById("StickyAddToCart").classList.add("button--primary");
            document.getElementById("AddToCart").classList.remove("button--ternary");
            document.getElementById("StickyAddToCart").classList.remove("button--ternary");
        }
    }
    else {
        if(/^[\x00-\x7F]*$/.test(document.getElementById("text_input").value)==false){
            document.getElementById("pc_remark").style.color= "red";
        }
        document.getElementById("AddToCart").disabled = true;
        document.getElementById("StickyAddToCart").checked = true;
        document.getElementById("AddToCart").classList.remove("button--primary");
        document.getElementById("StickyAddToCart").classList.remove("button--primary");
        document.getElementById("AddToCart").classList.add("button--ternary");
        document.getElementById("StickyAddToCart").classList.add("button--ternary");
    }
});


var parent = document.getElementById("text_position_containner");
for (var i = 0; i < parent.children.length; i++) {

    //real click event
    parent.children[i].addEventListener("click", function () {
        (function(event) {
            var position = Array.prototype.indexOf.call(event.parentElement.children, event)+1;
            if (event != undefined) {
                var parent = event.parentElement;
                var children = parent.children;
                for (var i = 0; i < children.length; i++) {
                    children[i].classList.remove("selected");
                }
                event.classList.add("selected");
            }
            let offset = 0;
            text.x(0);
            text.y(0);
        
            if (position == "1") {
                
                text_position = "1";
                (function (angle) {
                    (function() {
            var rect = text;
            if (rect.offsetX() == 0 && rect.offsetY() == 0) {
                rect.offset({ x: rect.width() / 2, y: rect.height() / 2 });
                rect.position({ x: rect.position().x + rect.offsetX(), y: rect.position().y + rect.offsetY() })
            }
            return null;
        })();
                text.rotation(angle);
                })(270);
                text.align("left");
                text.fontSize(font_Mapping.get(text_font)[0][0]*container.offsetWidth/400),
                text.x(container.offsetWidth * 0.35+ font_Mapping.get(text_font)[0][1]*container.offsetWidth/400);
                text.y(container.offsetHeight * 0.35+ font_Mapping.get(text_font)[0][2]*container.offsetWidth/400);
            }
            //REAL 2
            if (position == "2") {
                text_position = "2";
                (function (angle) {
                    (function() {
            var rect = text;
            if (rect.offsetX() == 0 && rect.offsetY() == 0) {
                rect.offset({ x: rect.width() / 2, y: rect.height() / 2 });
                rect.position({ x: rect.position().x + rect.offsetX(), y: rect.position().y + rect.offsetY() })
            }
            return null;
        })();
                    text.rotation(angle);
                })(270);
                text.align("left");
                text.fontSize(font_Mapping.get(text_font)[0][0]*container.offsetWidth/400),
                text.x(container.offsetWidth * 0.65+ font_Mapping.get(text_font)[1][1]*container.offsetWidth/400);
                text.y(container.offsetHeight * 0.35+ font_Mapping.get(text_font)[1][2]*container.offsetWidth/400);
                text.fontSize(font_Mapping.get(text_font)[1][0]*container.offsetWidth/400);



            }
            //REAL 3
            if (position == "3") {
                
                text_position = "3";
                (function (angle) {
                    (function() {
            var rect = text;
            if (rect.offsetX() == 0 && rect.offsetY() == 0) {
                rect.offset({ x: rect.width() / 2, y: rect.height() / 2 });
                rect.position({ x: rect.position().x + rect.offsetX(), y: rect.position().y + rect.offsetY() })
            }
            return null;
        })();
                text.rotation(angle);})(0);
                text.align("center");
                text.x(container.offsetWidth * 0.5+font_Mapping.get(text_font)[2][1]*container.offsetWidth/400);
                text.y(container.offsetHeight * 0.5 +font_Mapping.get(text_font)[2][2]*container.offsetWidth/400);
                text.fontSize(font_Mapping.get(text_font)[2][0]*container.offsetWidth/400);
            }
            //REAL 4
            if (position == "4") {
                text.align("center");
                text_position = "4";
                (function (angle) {
                    (function() {
            var rect = text;
            if (rect.offsetX() == 0 && rect.offsetY() == 0) {
                rect.offset({ x: rect.width() / 2, y: rect.height() / 2 });
                rect.position({ x: rect.position().x + rect.offsetX(), y: rect.position().y + rect.offsetY() })
            }
            return null;
        })();
                text.rotation(angle);
                })(0);
                text.align("center");
                text.fontSize(font_Mapping.get(text_font)[3][0]*container.offsetWidth/400);
                text.x(container.offsetWidth * 0.5+font_Mapping.get(text_font)[3][1]*container.offsetWidth/400);
                text.y(container.offsetHeight * 0.85 +font_Mapping.get(text_font)[3][2]*container.offsetWidth/400);
                
            }
        })

        (this);
    });
}

var parent = document.getElementById("text_color_containner");
for (var i = 0; i < parent.children.length; i++) {
    parent.children[i].addEventListener("click", function () {
        (function(event) {
    text.fill(event.style.backgroundColor);
    //remove all class "selected" in same parent 
    var parent = event.parentElement;
    var children = parent.children;
    for (var i = 0; i < children.length; i++) {
        children[i].classList.remove("selected");
    }
    event.classList.add("selected");

    layer_One.draw();
})(this);
    });
}
var parent = document.getElementById("pc_font_containner");
for (var i = 0; i < parent.children.length; i++) {
    parent.children[i].addEventListener("click", function () {
        (function (event) {
    text_font=event.style.fontFamily;
    changeFont(event.style.fontFamily);
    var parent = event.parentElement;
    var children = parent.children;
    for (var i = 0; i < children.length; i++) {
        children[i].classList.remove("selected");
    }
    event.classList.add("selected");

    layer_One.draw();
})(this);
    });
}

var els = document.querySelectorAll('flickity-controls')
for (var i = 0; i < els.length; i++) {
    els[i].remove();
}


function changeFont(font_family){
    text.fontFamily(font_family);
    
    if (text_position == "1") {
                
        text_position = "1";
        (function (angle) {
            (function() {
    var rect = text;
    if (rect.offsetX() == 0 && rect.offsetY() == 0) {
        rect.offset({ x: rect.width() / 2, y: rect.height() / 2 });
        rect.position({ x: rect.position().x + rect.offsetX(), y: rect.position().y + rect.offsetY() })
    }
    return null;
})();
        text.rotation(angle);
        })(270);
        text.align("left");
        text.fontSize(font_Mapping.get(text_font)[0][0]*container.offsetWidth/400),
        text.x(container.offsetWidth * 0.35+ font_Mapping.get(text_font)[0][1]*container.offsetWidth/400);
        text.y(container.offsetHeight * 0.35+ font_Mapping.get(text_font)[0][2]*container.offsetWidth/400);
    }
    //REAL 2
    if (text_position == "2") {
        text_position = "2";
        (function (angle) {
            (function() {
    var rect = text;
    if (rect.offsetX() == 0 && rect.offsetY() == 0) {
        rect.offset({ x: rect.width() / 2, y: rect.height() / 2 });
        rect.position({ x: rect.position().x + rect.offsetX(), y: rect.position().y + rect.offsetY() })
    }
    return null;
})();
            text.rotation(angle);
        })(270);
        text.align("left");
        text.fontSize(font_Mapping.get(text_font)[0][0]*container.offsetWidth/400),
        text.x(container.offsetWidth * 0.65+ font_Mapping.get(text_font)[1][1]*container.offsetWidth/400);
        text.y(container.offsetHeight * 0.35+ font_Mapping.get(text_font)[1][2]*container.offsetWidth/400);
        text.fontSize(font_Mapping.get(text_font)[1][0]*container.offsetWidth/400);



    }
    //REAL 3
    if (text_position == "3") {
        
        text_position = "3";
        (function (angle) {
            (function() {
    var rect = text;
    if (rect.offsetX() == 0 && rect.offsetY() == 0) {
        rect.offset({ x: rect.width() / 2, y: rect.height() / 2 });
        rect.position({ x: rect.position().x + rect.offsetX(), y: rect.position().y + rect.offsetY() })
    }
    return null;
})();
        text.rotation(angle);})(0);
        text.align("center");
        text.x(container.offsetWidth * 0.5+font_Mapping.get(text_font)[2][1]*container.offsetWidth/400);
        text.y(container.offsetHeight * 0.5 +font_Mapping.get(text_font)[2][2]*container.offsetWidth/400);
        text.fontSize(font_Mapping.get(text_font)[2][0]*container.offsetWidth/400);
    }
    //REAL 4
    if (text_position == "4") {
        text.align("center");
        text_position = "4";
        (function (angle) {
            (function() {
    var rect = text;
    if (rect.offsetX() == 0 && rect.offsetY() == 0) {
        rect.offset({ x: rect.width() / 2, y: rect.height() / 2 });
        rect.position({ x: rect.position().x + rect.offsetX(), y: rect.position().y + rect.offsetY() })
    }
    return null;
})();
        text.rotation(angle);
        })(0);
        text.align("center");
        text.fontSize(font_Mapping.get(text_font)[3][0]*container.offsetWidth/400);
        text.x(container.offsetWidth * 0.5+font_Mapping.get(text_font)[3][1]*container.offsetWidth/400);
        text.y(container.offsetHeight * 0.85 +font_Mapping.get(text_font)[3][2]*container.offsetWidth/400);
        
    }
    layer_One.draw();
}
